import { Box, Button, IconButton, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import * as XLSX from "xlsx";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import EditOrderModal from "../../../EditOrderModal";
import { handleEditOrderModal, showAlertSnackbar } from "../../../../reducers/uiSlice";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, getBranchById, getScanSatus } from "../../../../utilities/common";
import KeyAccountUpdateDialog from "../../IncidentKeyAccount/KeyAccountUpdateDialog";
import { getPartnerList } from "../../../../actions/mmActions";
import FullscreenLoading from "../../../Common/FullscreenLoading";
import { searchKeyAccount } from "../../../../actions/incidentManagementActions";
import { getChargeReason, getPaymentCycle, viewPayroll } from "../../../../actions/payRollAdjustmentAction";
import PaymentAdjustmentDialog from "../../../PayrollAdjustment/PayRollTable/PaymentAdjustmentDialog";

const useStyles = makeStyles((theme) => ({
    statisticsContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '1rem',
        marginTop: '-1rem',
        color: 'white',
        margin: 2
    },
    paragraphSpacing: {
        marginRight: '1rem', // 这里是给每个<p>标签设置1rem的右边距
    },
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    },
    leftSection: {
        paddingTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function MultiSearchTable(props) {
    const { t } = useTranslation('incidentManagement');
    const PAGE_SIZE = 20;
    const classes = useStyles();
    const dispatch = useDispatch();
    const branchList = useSelector(state => state.common.branches);
    const userList = useSelector(state => state.common.users);
    const statusList = useSelector(state => state.incidentManagement.statusList);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [partnerList, setPartnerList] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [keyAccountData, setKeyAccountData] = useState([]);
    const [payrollDialogType, setPayrollDialogType] = useState('');
    const [openPayrollAdjustmentDialog, setOpenPayrollAdjustmentDialog] = useState(false);
    const [chargeReason, setChargeReason] = useState(null);
    const [timezone, setTimezone] = useState('');
    const [payrollDetail, setPayrollDetail] = useState([]);
    const [payrollFileDetail, setPayrollFileDetail] = useState([]);

    const [payRollList, setPayRollList] = useState([
        {
            id: 0,
            label: t('payment_cycle'),
            key: "payment_cycle",
            list: {},
            onlyManagerAccess: false,
            length: 4
        },
        {
            id: 1,
            label: t('status'),
            list: [
                {
                    id: 0,
                    text: t('new_entry'),
                    value: 1
                },
                {
                    id: 1,
                    text: t('to_be_reviewed'),
                    value: 2
                },
                {
                    id: 2,
                    text: t('approval'),
                    value: 3
                }

            ],
            onlyManagerAccess: false,
            length: 2
        },
        {
            id: 2,
            label: t('deduction_subsidy'),
            list: [
                {
                    id: 0,
                    text: t('all'),
                    value: -1
                },
                {
                    id: 1,
                    text: t('deduction'),
                    value: 1
                },
                {
                    id: 2,
                    text: t('subsidy'),
                    value: 2
                }

            ],
            onlyManagerAccess: false,
            length: 2
        },
        {
            id: 3,
            label: t('reason'),
            list: [],
            onlyManagerAccess: true,
            length: 3
        }
    ]);
    const getNameById = (params, list) => {
        //getValue from data-grid is bugged in this current version
        return _.find(list, { 'id': params.value })?.name || ""
    }

    function getRefundStatus(params) {
        if (params.value === 1) {
            return "Refund";
        } else if (params.value === 0) {
            return "Not refund";
        }
        return "";
    }

    function getTransIdDisplay(params) {
        if (params.value === null) {
            return "Not deducted";
        }
        return params.value; // Otherwise, just return the actual value
    }

    useEffect(() => {
        const branchTimezone = _.filter(
            Object.values(JSON.parse(window.localStorage.getItem('branches'))), (item) => {
                return item.city === parseInt(window.localStorage.getItem('user_city'));
            })
        if (!_.isEmpty(branchTimezone)) {
            setTimezone(branchTimezone[0]?.time_zone)
        }
        dispatch(getPaymentCycle())
            .then((res) => {
                let arr = _.cloneDeep(payRollList);
                arr[0].list = res;
                setPayRollList(arr);
            })
            .catch(() => {
                setIsDataLoading(false);
            })
            .finally(() => {
            })
        dispatch(getPartnerList()).then((res) => {
            setPartnerList(res);
        })
        dispatch(getChargeReason())
            .then((res) => {
                setChargeReason(res);
            })
    }, []);

    const handleCellClick = (cellParams) => {
        if (cellParams.field === 'key_account') {
            setIsDataLoading(true);
            const searchParams = {
                name: cellParams.value ?? 0,
            };

            dispatch(searchKeyAccount(searchParams))
                .then((response) => {
                    setKeyAccountData(response);
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: t('search_success'),
                        type: 'success'
                    }));
                })
                .catch((error) => {
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: t('search_failed'),
                        type: 'error'
                    }));
                    setKeyAccountData([]);  // Clear the table data
                })
                .finally(() => {
                    console.log(keyAccountData);
                    setIsDialogOpen(true);
                    setIsDataLoading(false);
                });
        }
    }

    const Column = [
        {
            field: 'tracking_number',
            headerName: t('tracking_number'),
            width: 200,
            renderCell: (params) => (
                <Button
                    onClick={() => _handleEditOrderModal(true, params.value)}
                    style={{
                        cursor: 'pointer',
                        color: 'orange',
                        textDecoration: 'underline',
                    }}
                >
                    {params.value}
                </Button>
            ),
        },
        { field: 'shipping_staff_id', headerName: t('serch_by_driver'), width: 140, valueGetter: (params) => params.value ? params.value : '' },
        { field: 'warehouse', headerName: t('warehouse'), width: 210, valueFormatter: (params) => getBranchById(params.value, branchList)?.name.replace("Warehouse", "").trim() || params.value },
        { field: 'driver_dispatches_record', headerName: t('scan_status'), width: 160, valueGetter: (params) => t('editOrder:' + getScanSatus(params.value)) },

        {
            field: 'last_tracking_path',
            headerName: t('last_tracking_path'),
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'last_path_update',
            headerName: t('last_path_update'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'incident_id',
            headerName: t('incident_id'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            // renderCell: (params) => (
            //     <Button
            //         onClick={() => props.openIncidentForm({ open: true, id: params.value })}
            //         style={{
            //             cursor: 'pointer',
            //             color: 'orange',
            //             textDecoration: 'underline',
            //             minWidth: 100,
            //         }}
            //         fullWidth
            //     >
            //         {params.value}
            //     </Button>
            // ),
        },
        { field: 'status', headerName: t('investigation_status_short'), width: 120, valueGetter: (params) => getNameById(params, statusList.incidentStatusList) },
        {
            field: 'trans_id',
            headerName: t('trans_id'),
            width: 150, align: 'center',
            valueGetter: getTransIdDisplay,
            renderCell: (params) => (
                <Button
                    onClick={() => handleRowClick(params.value)}
                    style={{
                        cursor: 'pointer',
                        color: 'orange',
                        textDecoration: 'underline',
                    }}
                >
                    {params.value}
                </Button>
            ),
        },
        { field: 'consignee_refund', headerName: t('consignee_refund'), width: 150, align: 'center', valueGetter: getRefundStatus },
        { field: 'client_refund', headerName: t('client_refund'), width: 150, align: 'center', valueGetter: getRefundStatus },
        { field: 'incident_type', headerName: t('incident_type'), width: 300, valueGetter: (params) => getNameById(params, statusList.incidentTypeList) },
        {
            field: 'notes',
            headerName: t('notes'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'pod',
            headerName: t('pod'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'occurrence_time',
            headerName: t('occurrence_time'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'caused_by',
            headerName: t('caused_by'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        { field: 'caused_by', headerName: t('caused_by'), width: 175, valueGetter: (params) => getNameById(params, statusList.causedByList) },
        { field: 'result_type', headerName: t('result_type'), width: 225, valueGetter: (params) => getNameById(params, statusList.resultList) },
        { field: 'corrective_action', headerName: t('remedial_corrective_action'), width: 300, valueGetter: (params) => getNameById(params, statusList.correctiveActionList) },
        { field: 'review_type', headerName: t('review_type'), width: 250, valueGetter: (params) => getNameById(params, statusList.reviewTypeList) },
        { field: 'handler', headerName: t('handled_by'), width: 200, valueGetter: (params) => getUserById(params.value, userList)?.username || params.value },
        {
            field: 'close_time',
            headerName: t('close_time'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'key_account',
            headerName: t('key_account'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Button
                    onClick={() => handleCellClick(params)}
                    style={{
                        cursor: 'pointer',
                        color: 'orange',
                        textDecoration: 'underline',
                    }}
                >
                    {params.value}
                </Button>
            ),
        },
        {
            field: 'compensated_date',
            headerName: t('compensated_date'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        }
    ];

    const handleExportToExcel = () => {
        const data = rows.map((item) => {
            const rowData = {};
            Column.forEach((col) => {
                if (col.field) {
                    if (col.valueGetter) {
                        rowData[col.field] = col.valueGetter({ value: item[col.field] });
                    } else {
                        rowData[col.field] = item[col.field] || '';
                    }
                }
            });
            return rowData;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const fileName = "multiplesearch_data.xlsx"; // Change the file name if needed

        XLSX.writeFile(wb, fileName);
    };

    const rows = Array.isArray(props.data)
        ? props.data.map((item, index) => ({
            id: item.id,  // Use the array index as the unique ID for each row
            tracking_number: item.tno || '',
            shipping_staff_id: item.shipping_staff_id || '',
            warehouse: item.warehouse || '',
            driver_dispatches_record: item.scan_status || '',
            last_tracking_path: item.pathInfo || '',
            last_path_update: item.last_update_time || '',
            incident_id: item.id || '',
            trans_id: item.trans_id || '',
            consignee_refund: item.consignee_refund || '',
            client_refund: item.client_refund || '',
            incident_type: item.incident_type || '',
            status: item.status || '',
            notes: item.notes || '',
            driver_memo: item.driver_notes || '',
            pod: item.pod_verified || '',
            close_time: item.close_time || '',
            occurrence_time: item.occurrence_time || '',
            caused_by: item.caused_by || '',
            root_cause: item.root_cause || '',
            result_type: item.result_type || '',
            corrective_action: item.corrective_action || '',
            review_type: item.review_type || '',
            handler: item.handler || '',
            key_account: item.key_account || '',
            compensated_date: item.compensated_date || '',
        }))
        : [];

    const _handleEditOrderModal = (open, value) => {
        dispatch(handleEditOrderModal({
            open: open,
            orderIdentifier: value,
            type: 'tno'
        }));
    }

    const handleSelectionChange = (newSelectionModel) => {
        // newSelectionModel is an array of the selected rows' IDs
        console.log(newSelectionModel); // This will log the array of selected IDs
        props.onSelectedRowsChange(newSelectionModel); // Pass this array up to the parent component
      };

    const handleDialogClose = () => {
        setIsDataLoading(false)
        setOpenPayrollAdjustmentDialog(false)
        setPayrollDialogType()
    }

    const handleRowClick = (transId) => {
        setIsDataLoading(true);
        setPayrollDialogType('review');
        dispatch(viewPayroll(transId))
            .then((res) => {
                if (_.isNil(res[0])) {
                    dispatch(showAlertSnackbar({ message: "No Data Found", type: 'error' }))
                } else {
                    setPayrollDetail(res[0]);
                    setPayrollFileDetail(res?.files);
                }
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({ message: err.message, type: 'error' }))
            })
            .finally(() => {
                setIsDataLoading(false);
            })
        setOpenPayrollAdjustmentDialog(true)
    }

    return (
        <div style={{ width: 'flex', overflowY: 'auto', backgroundColor: '#303030' }}>
            <Box style={{ margin: 30, paddingRight: 40 }}>
                <PaymentAdjustmentDialog
                    chargeReason={chargeReason}
                    payrollDialogType={payrollDialogType}
                    handleDialogClose={handleDialogClose}
                    open={openPayrollAdjustmentDialog}
                    ableManagerAccess={true}
                    isDataloading={isDataLoading}
                    payrollDetail={payrollDialogType === 'review' ? payrollDetail : []}
                    payrollFileDetail={payrollDialogType === 'review' ? payrollFileDetail : []}
                    handleMangerApprove={true}
                    handleDeleteEntity={true}
                    handleRefresh={true}
                    handledataloading={true}
                    statusList={payRollList[1]}
                    timezone={timezone}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className={classes.statisticsContainer}>
                        <Typography className={classes.paragraphSpacing}>{t('common:total')} : {props.orderstatistics?.total_count ?? 0}</Typography >
                        <Typography className={classes.paragraphSpacing}>{t('driverCharged')} : {props.orderstatistics?.driver_charge ?? 0}</Typography >
                        <Typography className={classes.paragraphSpacing}>{t('refundConsignee')} : {props.orderstatistics?.refund_consignee ?? 0}</Typography >
                        <Typography className={classes.paragraphSpacing}>{t('refundClient')} : {props.orderstatistics?.client_refund_count ?? 0}</Typography >
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem', marginTop: '-1rem' }}>
                        <Button
                            id="incidentmanagement_compensatedtable_downloadexcel_button"
                            variant="contained"
                            color="primary"
                            startIcon={<CloudDownloadIcon />}
                            className={classes.Button}
                            onClick={() => handleExportToExcel()}
                        >
                            {t('download')}
                        </Button>
                    </div>
                </div>
                <DataGrid
                    className={classes.root}
                    columns={Column}
                    rows={rows || []}
                    pagination
                    pageSize={PAGE_SIZE}
                    rowsPerPageOptions={[PAGE_SIZE]}
                    loading={props.isDataLoading}
                    rowCount={rows?.length || 0}
                    style={{ height: '75vh', Width: 'flex' }}
                    checkboxSelection
                    onSelectionModelChange={handleSelectionChange}
                />
            </Box>
            <EditOrderModal
                onClose={() => _handleEditOrderModal(false)}
                handleClose={() => _handleEditOrderModal(false)}
            />
            <KeyAccountUpdateDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                partnerList={partnerList}
                selectedData={keyAccountData}
            />
            <FullscreenLoading open={isDataLoading} />
        </div>

    );
}

export default MultiSearchTable;